import LookupPage from "./lookup";

export default LookupPage;